import { postAppGraphql } from "./appGraphqlService";

export type GradeOption = {
  id: string;
  grade: string;
};

export type FetchGradesParams = {
  districtIds?: string[];
  schoolIds?: string[];
};

const GRADES_FILTER_QUERY = `
  query GradesFilter($districtIDs: [String!], $schoolIDs: [String!]) {
    allPredefinedGrades(
      districtIDs: $districtIDs
      schoolIDs: $schoolIDs
      sort: position
      order_by: Asc
    ) {
      id
      grade
    }
  }
`;

type GradesFilterResponse = {
  allPredefinedGrades?: GradeOption[];
};

function normalizeIdList(ids: string[] | undefined): string[] | undefined {
  const normalized = ids?.map((id) => id.trim()).filter(Boolean) ?? [];
  return normalized.length ? normalized : undefined;
}

export async function fetchGrades(
  token: string,
  { districtIds, schoolIds }: FetchGradesParams = {},
): Promise<GradeOption[]> {
  const normalizedDistrictIds = normalizeIdList(districtIds);
  const normalizedSchoolIds = normalizeIdList(schoolIds);

  const payload = await postAppGraphql<GradesFilterResponse>({
    token,
    operationName: "GradesFilter",
    query: GRADES_FILTER_QUERY,
    variables: {
      ...(normalizedDistrictIds ? { districtIDs: normalizedDistrictIds } : {}),
      ...(normalizedSchoolIds ? { schoolIDs: normalizedSchoolIds } : {}),
    },
  });

  return payload.data?.allPredefinedGrades ?? [];
}
